import { useState } from 'react';
import '../styles/team.css';

const categories = [
  'View All',
  'Management',
  'Managers',
  'Marketers',
  'Developer',
  'Dispatcher',
  'Social Media Manager',
  'Designer',
  'Frontdesk',
];

const teamMembers = [
  {
    name: 'Abdulfatai Abdulwasiu Aremu',
    role: 'Developer',
    email: 'wastech@Kieriantech.com',
    linkedin: 'https://linkedin.com/in/johndoe',
    twitter: 'https://twitter.com/johndoe',
    category: 'Developer',
  },
  {
    name: 'Umahi Chukwuemeka',
    role: 'Manager',
    email: 'Umahi@gmail.com',
    linkedin: 'https://linkedin.com/in/janesmith',
    twitter: 'https://twitter.com/janesmith',
    category: 'Managers',
  },
  {
    name: 'Isaac Terungwa  twoheba',
    role: 'delivery officers',
    email: 'Isaac@gmail.com',
    linkedin: 'https://linkedin.com/in/marktaylor',
    twitter: 'https://twitter.com/marktaylor',
    category: 'Dispatcher',
  },
  {
    name: 'Charles Ternenge Terhemen',
    role: 'delivery officers',
    email: 'Charles@gmail.com',
    linkedin: 'https://linkedin.com/in/lisawong',
    twitter: 'https://twitter.com/lisawong',
    category: 'Dispatcher',
  },
  {
    name: 'James uchechukwu odoh',
    role: 'delivery officers',
    email: 'James@gmail.com',
    linkedin: 'https://linkedin.com/in/emstone',
    twitter: 'https://twitter.com/emstone',
    category: 'Dispatcher',
  },
  {
    name: 'nweke divine success kosisochukwu',
    role: 'delivery officers',
    email: 'nweke@gmail.com',
    linkedin: 'https://linkedin.com/in/michaelbrown',
    twitter: 'https://twitter.com/michaelbrown',
    category: 'Dispatcher',
  },
  {
    name: 'Okolie salome daberechukwu',
    role: 'Frontdesk',
    email: 'Okolie@gmail.com',
    linkedin: 'https://linkedin.com/in/angelawhite',
    twitter: 'https://twitter.com/angelawhite',
    category: 'Frontdesk',
  },
  {
    name: 'Anthony egbede',
    role: 'delivery officers',
    email: 'Anthony@gmail.com',
    linkedin: 'https://linkedin.com/in/robertking',
    twitter: 'https://twitter.com/robertking',
    category: 'Dispatcher',
  },
  // {
  //   name: 'Sarah Young',
  //   role: 'Social Media Manager',
  //   email: 'sarah.young@example.com',
  //   linkedin: 'https://linkedin.com/in/sarahyoung',
  //   twitter: 'https://twitter.com/sarahyoung',
  //   category: 'Social Media Manager',
  // },
  // {
  //   name: 'Chris Evans',
  //   role: 'Dispatcher',
  //   email: 'chris.evans@example.com',
  //   linkedin: 'https://linkedin.com/in/chrisevans',
  //   twitter: 'https://twitter.com/chrisevans',
  //   category: 'Dispatcher',
  // },
  // {
  //   name: 'Ava Brooks',
  //   role: 'Designer',
  //   email: 'ava.brooks@example.com',
  //   linkedin: 'https://linkedin.com/in/avabrooks',
  //   twitter: 'https://twitter.com/avabrooks',
  //   category: 'Designer',
  // },
  // {
  //   name: 'Daniel Scott',
  //   role: 'Manager',
  //   email: 'daniel.scott@example.com',
  //   linkedin: 'https://linkedin.com/in/danielscott',
  //   twitter: 'https://twitter.com/danielscott',
  //   category: 'Managers',
  // },
  // {
  //   name: 'Natalie Reed',
  //   role: 'Marketer',
  //   email: 'natalie.reed@example.com',
  //   linkedin: 'https://linkedin.com/in/nataliereed',
  //   twitter: 'https://twitter.com/nataliereed',
  //   category: 'Marketers',
  // },
  // {
  //   name: 'Tom Harris',
  //   role: 'Developer',
  //   email: 'tom.harris@example.com',
  //   linkedin: 'https://linkedin.com/in/tomharris',
  //   twitter: 'https://twitter.com/tomharris',
  //   category: 'Developer',
  // },
  // {
  //   name: 'Rachel Adams',
  //   role: 'Frontdesk',
  //   email: 'rachel.adams@example.com',
  //   linkedin: 'https://linkedin.com/in/racheladams',
  //   twitter: 'https://twitter.com/racheladams',
  //   category: 'Frontdesk',
  // },
  // {
  //   name: 'Jacob Lee',
  //   role: 'Management',
  //   email: 'jacob.lee@example.com',
  //   linkedin: 'https://linkedin.com/in/jacoblee',
  //   twitter: 'https://twitter.com/jacoblee',
  //   category: 'Management',
  // },
  // {
  //   name: 'Ella Gray',
  //   role: 'Social Media Manager',
  //   email: 'ella.gray@example.com',
  //   linkedin: 'https://linkedin.com/in/ellagray',
  //   twitter: 'https://twitter.com/ellagray',
  //   category: 'Social Media Manager',
  // },

  // {
  //   name: 'Aria Coleman',
  //   role: 'Dispatcher',
  //   email: 'aria.coleman@example.com',
  //   linkedin: 'https://linkedin.com/in/ariacoleman',
  //   twitter: 'https://twitter.com/ariacoleman',
  //   category: 'Dispatcher',
  // },
  // {
  //   name: 'Caleb Patterson',
  //   role: 'Developer',
  //   email: 'caleb.patterson@example.com',
  //   linkedin: 'https://linkedin.com/in/calebpatterson',
  //   twitter: 'https://twitter.com/calebpatterson',
  //   category: 'Developer',
  // },
  // {
  //   name: 'Nora Burns',
  //   role: 'Marketer',
  //   email: 'nora.burns@example.com',
  //   linkedin: 'https://linkedin.com/in/noraburns',
  //   twitter: 'https://twitter.com/noraburns',
  //   category: 'Marketers',
  // },
];

function Team() {
  const [selectedCategory, setSelectedCategory] = useState('View All');

  const filteredMembers =
    selectedCategory === 'View All'
      ? teamMembers
      : teamMembers.filter((member) => member.category === selectedCategory);

  return (
    <div className='team-container'>
      <h1 className='team-title'>Our Team</h1>
      <p className='team-description'>
        Meet the passionate professionals driving our success.
      </p>

      <div className='team-category-buttons'>
        {categories.map((category) => (
          <button
            key={category}
            className={`team-category-btn ${
              selectedCategory === category ? 'active' : ''
            }`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <div className='team-grid'>
        {filteredMembers.map((member, index) => (
          <div key={index} className='team-card'>
            <div className='team-avatar-placeholder'>{member.name[0]}</div>
            <h3 className='team-name'>{member.name}</h3>
            <p className='team-role'>{member.role}</p>
            <p className='team-email'>{member.email}</p>
            <div className='team-socials'>
              <a href={member.linkedin} target='_blank' rel='noreferrer'>
                LinkedIn
              </a>
              <a href={member.twitter} target='_blank' rel='noreferrer'>
                X
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Team;
